import React from 'react';

// eslint-disable-next-line react/prefer-stateless-function
class BaseComponent extends React.Component {}

export default BaseComponent;
